import React, { useEffect } from 'react'
import { Formik } from 'formik'
import { makeStyles, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, LinearProgress, FormGroup, Checkbox } from '@material-ui/core'


let useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: 250,
        minWidth: 450,
        backgroundColor: "white",
        padding: 15,
        borderRadius: 8,
        [theme.breakpoints.down("700")]: {
            minWidth: '100% !important',
        },
    },
    gridBtns: {
        direction: 'rtl',
        marginTop: '10px',

        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            display: 'flex',
            flexDirection: 'column-reverse',
            flexWrap: 'wrap'
        },
    },
    btnOtlineBlack: {
        fontSize: 14,
        backgroundColor: "white",
        color: "black",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid black`,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "black",
            color: "white"
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            marginBottom: '10px',

        },
    },
    openAccountRed: {
        backgroundColor: theme.palette.light.type2,
        color: "white",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "#ffffff",
            color: theme.palette.light.type2,
            border: `1px solid ${theme.palette.light.type2}`,
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            width: '100%',
        },
    },
    loading: {
        width: "99%",
        margin: "auto",
        top: "4px",
        zIndex: 2,
    },
    list: {
        listStyle: 'number',
        padding: 0,
        width: '97%',
        marginLeft: 'auto'
        // marginLeftleft:20
    },
    desc: {
        marginBottom: 5,
        color: 'rgba(0,0,0,0.8)'
    },
    title: {
        marginBottom: 10,
        color: 'red',
        fontWeight: 'bold'
    }
}))


export default function Index({
    setIndexChild,
    open,
    setOpen,
    loading,
    option,
    setOption,
    oms,
    setOms,
    apiSubmitOms
}) {

    const classes = useStyles()

    useEffect(() => {
        if (!open) {
            setTimeout(() => {
                setIndexChild(0)
            }, 600);
        }
    }, [open])//eslint-disable-line react-hooks/exhaustive-deps 


    return (
        <>

            {
                loading && (
                    <LinearProgress className={classes['loading']} />
                )
            }

            <div className={classes['root']}>
                <div>
                    <h3>
                        سامانه های معاملاتی
                    </h3>
                </div>
                <hr />
                <div>

                </div>
                <div>

                    <div className={''}>
                        <div>
                            <p className={classes['title']}>
                                لطفا در انتخاب یا تغییر پنل معاملاتی خود  نسبت به موارد ذیل توجه فرمایید :
                            </p>
                            <ul className={classes['list']}>
                                <li>
                                    <p className={classes['desc']}>
                                        انجام فرایند تغییر سامانه معاملاتی حداقل سه روز کاری به طول می انجامد
                                    </p>
                                </li>
                                <li>
                                    <p className={classes['desc']}>
                                        در صورت تمایل نسبت به فرایند تغییر سامانه در نظر داشته باشید در سامانه معاملاتی مبداً نباید هیچ گونه سفارش باز ائم از معتبر تا لغو یا معتبر تا تاریخ  نداشته باشید
                                    </p>
                                </li>
                                <li>
                                    <p className={classes['desc']}>
                                        استفاده از خدمات  معاملات اختیار(آپشن) تنها از سامانه معاملاتی تدبیر-آنلاین پلاس امکان پذیر می باشد
                                    </p>
                                </li>
                                <li>
                                    <p className={classes['desc']}>
                                        سفارش خرید نمادهای تبعی (بیمه سهم) تنها از سامانه رایان-اکسیر امکان پذیر می باشد.
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <form >
                                <FormControl>
                                    <FormLabel id="demo-row-radio-buttons-group-label"></FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={oms}
                                        onChange={event => setOms( event.target.value)}
                                    >

                                        <FormControlLabel value="rayan" control={<Radio />} label="رایان" />
                                        <FormControlLabel value="tadbir" control={<Radio />} label="تدبیر" />
                                    </RadioGroup>
                                </FormControl>
                                <div>
                                    {
                                        oms === 'tadbir' && (
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Checkbox
                                                        checked={option}
                                                        onChange={(e) => setOption(e.target.checked)}
                                                        defaultChecked />}
                                                    label=" درخواست معاملات اختیار دارم"
                                                />
                                            </FormGroup>
                                        )
                                    }
                                </div>
                                <div className={classes['gridBtns']}>
                                    <Button className={classes.openAccountRed} onClick={() => setOpen(false)}>
                                        لغو
                                    </Button>

                                    <Button className={classes.btnOtlineBlack}
                                        onClick={() =>
                                            (!option | oms === 'rayan')
                                                ? apiSubmitOms()
                                                : setIndexChild(3)
                                        }
                                    >
                                        {
                                            (!option | oms === 'rayan')
                                                ? 'ثبت درخواست'
                                                : 'ادامه'
                                        }

                                    </Button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
